import appStore from 'store';
import api from './api';
import { STATUS_TYPE, PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: '0',
    detailDialogVisible: false,
    auditDetail: {},
    pagination: PAGINATION,
    totalCount: 0,
    countryCodeList: []
  },
  getters: {
    auditList: state =>
      state.auditList.slice().map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.status + '']
        };
      }),
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.list;
      state.totalCount = payload.totalCount;
    },
    changeTab(state, payload) {
      payload == 'null' ? state.activeTab = 'hight' : state.activeTab = payload;
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setAuditDetail(state, payload) {
      state.auditDetail = {
        ...payload,
        __attachUrl: payload.imgUrl
          ? payload.imgUrl.split(',')
          : null,
        faceImgArr: payload.extFaceInfo ? ['data:image/png;base64,' + JSON.parse(payload.extFaceInfo).faceImg] : null,
        idImageArr: payload.extIdInfo ? ['data:image/png;base64,' + JSON.parse(payload.extIdInfo).idImage] : null,
      };
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCountryCodeList(state, payload) {
      state.countryCodeList = payload;
    }
  },
  actions: {
    list({ commit }, query) { // eslint-disable-line
      commit('changeTab', query.status + '');
      commit('setPagination', { page: query.page, size: query.size });

      api.getAuditList(query).then(({ data }) => {
        commit('setAuditList', data);
      });
    },
    approve({ commit }, data) { // eslint-disable-line
      return new Promise(resolve => {
        api.approveAudit(data).then(res => {
          resolve(res);
        });
      });
    },
    detail({ commit }, id) {
      api.getAuditDetail(id).then(({ data }) => {
        commit('setAuditDetail', data);
      });
    },
    details({ commit }, id) {
      api.getoldDetail(id).then(({ data }) => {
        commit('setAuditDetail', data);
      });
    },
    getCountryCodeList({ commit }) {
      api.getCountryCodeList().then(({ data }) => {
        commit('setCountryCodeList', data);
      });
    },
    getExcel(content, data) {
      return api.getExcel(data).then(res => {
        return res
      });
    },
    RollBack(content, data) {
      return api.RollBack(data);
    },
    getIdOK({ commit }, query) {
      api.getIdOK(query).then(({ data }) => {
        commit('setAuditList', data);
      });
    }
  }
};

appStore.registerModule('kycAudit', store);
